import Template from "../app/Template";
import Card from "../layout/Card";
import TextInput from "../forms/TextInput";
import TextArea from "../forms/TextArea";
import Dropdown from "../forms/Dropdown";
import { useState } from "react";
import Button from "../layout/Button";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { useAppDispatch } from "../../hooks";
import { sendContactUsEmail } from "../../slices/auth";
import { addAlert } from "../../slices/alert";
import { generateTranslatedText } from "../../utils/boilerplate";


export default function Contact() {
  const dispatch = useAppDispatch();


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    agree_tos: false,
    agree_marketing: false,
  });

  function showSendButton() {
    if (formData.name && formData.email && formData.subject && formData.message && formData.agree_tos) {
      return true;
    }
    return false;
  }

  async function sendForm(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    const {
      name,
      email,
      subject,
      message,
      agree_tos: agreeTos,
      agree_marketing: agreeMarketing,
    } = formData;

    // Dispatch action
    const res: any = await dispatch(sendContactUsEmail({
      name,
      email,
      subject,
      message
    }))
    if (res.payload.status === 200) {
      dispatch(addAlert(generateTranslatedText("contact_us_success", "EN"), "mint-green"));
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
        agree_tos: false,
        agree_marketing: false,
      });
    } else {
      dispatch(addAlert(generateTranslatedText("contact_us_error", "EN"), "orange"));
    }
  }

  const dropdownSelect: Array<{ label: string; value: string }> = [
    { label: "Public speaking", value: "public-speaking" },
    { label: "General enquiry", value: "general-inquiry" },
    { label: "Partnership", value: "partnership" },
    { label: "Feedback", value: "feedback" },
    { label: "Support", value: "support" },
    { label: "Other", value: "other" },
  ]
  return (
    <Template>

      {/* Hero */}
      <div className="hidden md:block">
        <div
          className="h-[600px] md:h-[700px] lg:h-[900px] flex items-center px-4 md:px-8 lg:px-12"
          style={{
            // Image path is relative to the 'public' folder
            backgroundImage: 'url("/img/graphics/images/Contact.JPG")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            position: 'relative', // Ensures child elements with absolute positioning are positioned relative to this container
          }}
        >
          <Card className="mr-auto w-4/5 lg:w-3/5 xl:w-1/2 grid grid-cols-1 gap-y-4 relative" paddingX="px-8" paddingY="py-8">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-3xl md:text-5xl lg:text-6xl font-bold">Contact us</h1>
            </div>

            {/* Contact us form */}
            <form className="grid grid-cols-1 gap-y-2">

              {/* Name */}
              <TextInput
                id="contact-us-name"
                type="text"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Name"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                value={formData.name}
              />

              {/* Email */}
              <TextInput
                id="contact-us-email"
                type="text"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Email"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                value={formData.email}
              />

              {/* Subject */}
              <Dropdown
                id="contact-us-dropdown"
                className="w-3/4"
                bgColour="off-white"
                textColour="dark-grey"
                borderClass="border border-black py-2"
                showLabel={false}
                required={false}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                value={formData.subject}
              >
                <option key="" value="">
                  Subject
                </option>
                {dropdownSelect.map((opt, idx) => (
                  <option key={`${idx}-${opt.value}`} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Dropdown>

              {/* Message */}
              <TextArea
                id="contact-us-message"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Message"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                value={formData.message}
              />

              {/* Agree to Terms of Service */}
              <div className="mt-6 space-y-6">
                <div className="relative flex gap-x-3">
                  <div className="flex h-6 items-center">
                    <input
                      id={`checkbox-tos`}
                      className={`h-4 w-4 rounded border-1 border-black text-dark-grey focus:ring-black`}
                      name="agree_tos"
                      value=""
                      type="checkbox"
                      onChange={(e) => setFormData({ ...formData, agree_tos: !formData.agree_tos })}
                      checked={formData.agree_tos}
                    />
                  </div>
                  <div className="text-sm leading-6">
                    <label className={`text-black`}>
                      By submitting this form, you confirm that you have read and agree to our <a href="/privacy-policy" target="_blank" rel="noreferrer" className="underline">Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className="underline">Terms of Service</a>.
                    </label>
                  </div>
                </div>
              </div>

              {/* Agree to Marketing */}
              {/* <div className="mt-6 space-y-6">
                <div className="relative flex gap-x-3">
                  <div className="flex h-6 items-center">
                    <input
                      id={`checkbox-marketing`}
                      className={`h-4 w-4 rounded border-1 border-black text-dark-grey focus:ring-black`}
                      name="agree_marketing"
                      value=""
                      type="checkbox"
                      onChange={(e) => setFormData({ ...formData, agree_marketing: !formData.agree_marketing })}
                      checked={formData.agree_marketing}
                    />
                  </div>
                  <div className="text-sm leading-6">
                    <label className={`text-black`}>
                      I agree to RaiseDiversity using my contact details to get in touch to share marketing tips, other content, and the latest offers.
                    </label>
                  </div>
                </div>
              </div> */}

              {/* Send button */}
              {showSendButton() && (
                <Button
                  bgColour="dark-blue"
                  textColour="black"
                  borderColour="none"
                  onClick={sendForm}
                  className="mt-6"
                >
                  <span className="flex items-center justify-center gap-x-2 text-white">
                    Send
                  </span>
                </Button>
              )}
            </form>

            {/* Bubbles */}
            <img
              src="/img/graphics/bubbles/bubble-top-green.svg"
              alt="Bubble"
              className="absolute w-72 object-cover -right-20 top-20 z-0"
            />
            <img
              src="/img/graphics/bubbles/bubble-top-orange.svg"
              alt="Bubble"
              className="absolute w-24 object-cover right-0 top-12 z-0"
            />
          </Card>
        </div>
      </div>

      <div className="block md:hidden">
        <div
          className="h-fit bg-white relative py-12"
        >
          <Card colour="white" className="w-full grid grid-cols-1 gap-y-4" paddingX="px-8" paddingY="py-8">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-3xl md:text-5xl lg:text-6xl font-bold">Contact us</h1>
            </div>

            {/* Contact us form */}
            <form className="grid grid-cols-1 gap-y-2">

              {/* Name */}
              <TextInput
                id="contact-us-name"
                type="text"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Name"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                value={formData.name}
              />

              {/* Email */}
              <TextInput
                id="contact-us-email"
                type="text"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Email"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                value={formData.email}
              />

              {/* Subject */}
              <Dropdown
                id="contact-us-dropdown"
                className="w-3/4"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                showLabel={false}
                required={false}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                value={formData.subject}
              >
                <option key="" value="">
                  Subject
                </option>
                {dropdownSelect.map((opt, idx) => (
                  <option key={`${idx}-${opt.value}`} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Dropdown>

              {/* Message */}
              <TextArea
                id="contact-us-message"
                bgColour="transparent"
                borderClass="border-1 border-dark-grey"
                placeholder="Name"
                widthClass="w-3/4"
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                value={formData.message}
              />

              {/* Agree to Terms of Service */}
              <div className="mt-6 space-y-6">
                <div className="relative flex gap-x-3">
                  <div className="flex h-6 items-center">
                    <input
                      id={`checkbox-tos`}
                      className={`h-4 w-4 rounded border-1 border-black text-dark-grey focus:ring-black`}
                      name="agree_tos"
                      value=""
                      type="checkbox"
                      onChange={(e) => setFormData({ ...formData, agree_tos: !formData.agree_tos })}
                      checked={formData.agree_tos}
                    />
                  </div>
                  <div className="text-sm leading-6">
                    <label className={`text-black`}>
                      By submitting this form, you confirm that you have read and agree to our <a href="/privacy-policy" target="_blank" rel="noreferrer" className="underline">Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className="underline">Terms of Service</a>. Your information will be handled in accordance with GDPR regulations.
                    </label>
                  </div>
                </div>
              </div>

              {/* Agree to Marketing */}
              <div className="mt-6 space-y-6">
                <div className="relative flex gap-x-3">
                  <div className="flex h-6 items-center">
                    <input
                      id={`checkbox-marketing`}
                      className={`h-4 w-4 rounded border-1 border-black text-dark-grey focus:ring-black`}
                      name="agree_marketing"
                      value=""
                      type="checkbox"
                      onChange={(e) => setFormData({ ...formData, agree_marketing: !formData.agree_marketing })}
                      checked={formData.agree_marketing}
                    />
                  </div>
                  <div className="text-sm leading-6">
                    <label className={`text-black`}>
                      I agree to RaiseDiversity using my contact details to get in touch to share marketing tips, other content, and the latest offers.
                    </label>
                  </div>
                </div>
              </div>
            </form>

          </Card>
        </div>
      </div>

    </Template>
  );
}
